import PersistentTable from 'components/InvestmentAnalyser/PersistentTable';
import { getStringObject } from 'components/InvestmentAnalyser/utils';
import React, { useMemo, useState, useEffect } from 'react';
import Checkbox from 'components/Checkbox/Checkbox';
import selectors from 'store/selectors';
import { connect } from 'react-redux';
import { MRT_ColumnDef } from 'material-react-table';
import { Notify } from 'utils';
import { resetTableState } from 'components/InvestmentAnalyser/utils';

const BenchmarkTable = ({
  benchmarks,
  isFirmAdmin,
  cap = null,
  amountSelected = null,
  setBenchmarks = null,
  name = 'firm-benchmarks',
  defaultPageSize = 25,
  canSelectAll = false,
  lockedToFirmAdmins = false
}: any) => {
  const [currentBenchmarks, setCurrentBenchmarks] = useState(benchmarks);
  const [allSelected, setAllSelected] = useState(false);
  const [count, setCount] = useState(0);

  const updateBenchmarks = (list: any) => {
    setCurrentBenchmarks(list);

    if (setBenchmarks) {
      setBenchmarks(list);
    }
  };

  const reset = (key: string) => {
    resetTableState(key);
    setCount(count + 1);
  };

  const toggleAllSelected = () => {
    updateBenchmarks(
      benchmarks.map((benchmark: any) => ({
        ...benchmark,
        selected: !allSelected
      }))
    );
  };

  useEffect(() => {
    setAllSelected(benchmarks.every((benchmark: any) => benchmark.selected));
    updateBenchmarks(benchmarks);
  }, [benchmarks]);

  const columns = useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: 'selected',
        header: 'Selected',
        filterVariant: 'checkbox',
        Cell: ({ row }: any) => {
          return (
            <Checkbox
              disabled={lockedToFirmAdmins && !isFirmAdmin}
              onClick={() => {
                if (cap && amountSelected && cap == amountSelected) {
                  Notify.warn(`You can only add up to ${cap} benchmarks.`);
                  return;
                }
                const updatedBenchmarks = [...currentBenchmarks];
                updatedBenchmarks.splice(row.index, 1, {
                  ...updatedBenchmarks[row.index],
                  selected: !updatedBenchmarks[row.index].selected
                });
                updateBenchmarks(updatedBenchmarks);
              }}
              isChecked={row.original.selected}
            />
          );
        }
      },
      {
        accessorKey: 'type',
        header: 'Type',
        filterVariant: 'select',
        enableColumnFilterModes: false
      },
      {
        accessorKey: 'name',
        header: 'Name',
        ...getStringObject('name', 'contains')
      }
    ],
    [currentBenchmarks]
  );

  return (
    <div>
      <div style={{ display: 'flex' }}>
        {canSelectAll && (
          <div
            className="dashboardLink"
            style={{ marginLeft: '0.6rem' }}
            onClick={() => toggleAllSelected()}
          >
            {allSelected ? 'Deselect all' : 'Select all'}
          </div>
        )}
        <div
          className="dashboardLink"
          style={{ marginRight: '0.6rem', marginLeft: 'auto' }}
          onClick={() => reset(name)}
        >
          Reset Filters
        </div>
      </div>
      <PersistentTable
        key={`${name}_${count}`}
        tableId={name}
        columns={columns.filter((row: any) => row.accessorKey !== 'allocation')}
        data={currentBenchmarks}
        enablePagination
        manualPagination={false}
        defaultPin={null}
        defaultPageSize={defaultPageSize}
        enableBottomToolbar
      />
    </div>
  );
};

export default connect(
  (state: any) => ({
    isFirmAdmin: selectors.advisorSelectors.isFirmAdmin(state)
  }),
  null
)(BenchmarkTable);
